import WithRender from "../../templates/base/packingOptions.html";
import { mapGetters, mapActions } from "vuex";
import { i18n } from "../../i18n.js";
import { validateInput } from "../../helpers/helpers";

export default WithRender({
  computed: {
    ...mapGetters(["getPackingOptions", "getLimits"]),
    name: function () {
      return i18n.t("pv_" + this.propsData.label);
    },
    option() {
      return this.propsData.value;
    }
  },
  methods: {
    ...mapActions(["setPackingOption"]),
    updateOption(event) {
      var newValue = event.target.value;
      var attribute = this.propsData.code.replace("packing_format_", "");
      var min = null;
      var max = null;
      if (this.getLimits[attribute]) {
        min = this.getLimits[attribute].min;
        max = this.getLimits[attribute].max;
      }
      var optionValid = validateInput(newValue, this.propsData.label, min, max);
      if (!optionValid.valid) {
        this.$swal({ text: optionValid.msg, icon: "warning" });
        this.setPackingOption({
          code: this.propsData.code,
          value: this.propsData.value
        });
        return;
      }
      this.setPackingOption({
        code: this.propsData.code,
        value: newValue
      });
    }
  },
  props: ["propsData"]
});
